<template>
  <form class="dropzone" :class="{ viewonly }">
    <!-- Not displayed, just for Dropzone's `dictDefaultMessage` option -->
    <div id="dropzone-message" style="display: none">
      <span class="dropzone-title">
        <icon-upload/>
        <span class="text">{{ $t('create.uploadChooseFile') }}...</span>
      </span>
    </div>
    <modal class="modal-crop" v-show="isModalOpen">
      <template v-slot:body>
        <div class="modal-crop-left">
          <img src alt ref="cropperImg">
        </div>
        <div class="modal-crop-right">
          <div class="crop-wrapper" :style="{ backgroundColor: background ? background : '#ddd', maxWidth: screenWidth + 'px' }">
            <div class="crop-preview" ref="preview" :style="previewStyles">
            </div>
            <img class="crop-preview-screen" :src="previewSrc" alt>
          </div>
          <div class="error" v-if="error">
            <span v-if="error === 'lowres'">{{ $t('create.uploadCroppedSmall') }}</span>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button @click.prevent="cancel">{{ $t('buttons.cancel') }}</button>
        <button @click.prevent="saveAndUpload" ref="saveButton">{{ $t('buttons.saveUpload') }}</button>
      </template>
    </modal>
  </form>
</template>

<script>
import IconUpload from '@/assets/images/icons/upload_icon.svg'
import Dropzone from 'dropzone'
// import 'dropzone/dist/dropzone.css'
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import Modal from '@/components/Modal.vue'
import MediaService from '@/services/MediaService'

export default {
  name: 'dropzone',
  components: {
    IconUpload,
    Modal
  },
  props: {
    label: String,
    imageWidth: Number,
    imageHeight: Number,
    screenWidth: Number,
    screenHeight: Number,
    screenOffsetTop: Number,
    screenOffsetLeft: Number,
    previewSrc: String,
    value: [String, Boolean],
    viewonly: {
      type: Boolean,
      default: false
    },
    background: String,
    acceptedFiles: {
      type: String,
      default: 'image/png,image/jpeg,.png,.jpg,.jpeg'
    },
    mode: {
      type: String,
      default: 'local',
    },
  },
  data() {
    return {
      isModalOpen: false,
      initialEvent: null,
      uploadKey: null,
      error: null
    }
  },
  computed: {
    previewStyles() {
      // console.log(this.imageHeight, this.screenWidth, )
      return {
        top: (((100 * this.screenOffsetTop) / this.screenHeight) || 0) + '%',
        left: (((100 * this.screenOffsetLeft) / this.screenWidth) || 0) + '%',
        width: (((100 * this.imageWidth) / this.screenWidth) || 100) + '%',
        'padding-bottom': (((100 * this.imageHeight) / this.screenWidth) || 100) + '%',
        // 'max-width': this.imageWidth + 'px',
        // 'max-height': this.imageHeight + 'px'
      }
    }
  },
  methods: {
    cancel() {
      this.dropzone.removeAllFiles(true)
      this.isModalOpen = false
      this.cropper.destroy()
    },
    saveAndUpload() {
      if (this.mode === 'server') {
        this.$emit('cropdata', this.cropper.getData());
        // console.log(this.cachedFile);
        this.dropzone.removeFile(this.cachedFile);
        this.$emit('input', this.cachedFile.dataURL);
        this.cachedFile.cropped = true;
        this.dropzone.addFile(this.cachedFile);
        this.isModalOpen = false;
        this.cropper.destroy();
      } else {
        // Get the canvas with image data from Cropper.js
        const canvas = this.cropper.getCroppedCanvas({
          width: this.imageWidth,
          height: this.imageHeight,
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high',
        })
        // Turn the canvas into a Blob (file object without a name)
        if (window.HTMLCanvasElement.prototype.toBlob) {
          canvas.toBlob(blob => {
            // Return the file to Dropzone
            // this.done(blob)
            this.dropzone.removeFile(this.cachedFile)
            this.$emit('input', window.URL.createObjectURL(blob))
            var pos = this.cachedFile.name.lastIndexOf('.');
            blob.name = this.cachedFile.name.substr(0, pos < 0 ? this.cachedFile.name.length : pos);
            if (blob.name.length >= 58) blob.name = blob.name.substr(0, 58)
            blob.name = blob.name + '.png'
            blob.cropped = true
            this.dropzone.addFile(blob)
          })
          this.isModalOpen = false
          this.cropper.destroy()
        } else if (window.HTMLCanvasElement.prototype.msToBlob) {
          const blob = canvas.msToBlob()
          // Return the file to Dropzone
          // this.done(blob)
          this.dropzone.removeFile(this.cachedFile)
          this.$emit('input', window.URL.createObjectURL(blob))
          var pos = this.cachedFile.name.lastIndexOf('.');
          blob.name = this.cachedFile.name.substr(0, pos < 0 ? this.cachedFile.name.length : pos);
          if (blob.name.length >= 58) blob.name = blob.name.substr(0, 58)
          blob.name = blob.name + '.png'
          blob.cropped = true
          this.dropzone.addFile(blob)
          this.isModalOpen = false
          this.cropper.destroy()
        }
      }
    },
    updatePreview(detail) {
      const cropper = this.cropper
      const imageData = cropper.getImageData()
      const previewAspectRatio = detail.width / detail.height
      const previewImage = this.$refs.preview
        .getElementsByTagName('img')
        .item(0)
      const previewWidth = this.$refs.preview.offsetWidth
      const previewHeight = previewWidth / previewAspectRatio
      const imageScaledRatio = detail.width / previewWidth
      if (previewImage) {
        this.$refs.preview.style.height = previewHeight
        previewImage.style.width =
          imageData.naturalWidth / imageScaledRatio + 'px'
        previewImage.style.height =
          imageData.naturalHeight / imageScaledRatio + 'px'
        previewImage.style.marginLeft = -detail.x / imageScaledRatio + 'px'
        previewImage.style.marginTop = -detail.y / imageScaledRatio + 'px'
      } else {
        this.initialEvent = detail
      }

      const data = cropper.getData()
      if (data.width < this.imageWidth || data.height < this.imageHeight) {
        this.error = 'lowres'
      } else {
        this.error = null
      }
    }
  },
  mounted() {
    const vm = this

    window.URL = window.URL || window.webkitURL
    Dropzone.autoDiscover = false

    const options = {
      url: '/',
      method: 'put',
      sending(file, xhr) {
        const _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },
      hiddenInputContainer: this.$el,
      parallelUpload: 1,
      uploadMultiple: false,
      acceptedFiles: vm.acceptedFiles,
      header: '',
      dictDefaultMessage: document.querySelector('#dropzone-message').innerHTML,
      autoProcessQueue: false,
      // autoQueue: false,
      accept(file, done) {
        if (file.cropped) {
          const loader = vm.$loading.show()
          MediaService.getSignedURL(file)
            .then(resp => {
              if (resp && resp.data && resp.data.data && resp.data.data.url) {
                file.uploadURL = resp.data.data.url
                vm.uploadKey = resp.data.data.params.Key
                done()
                loader.hide()
                setTimeout(() => vm.dropzone.processFile(file))
              } else {
                loader.hide()
                done(
                  'Error getting a signed S3 upload URL',
                  resp.data.data.error
                )
              }
            })
            .catch(err => {
              loader.hide()
              done('Failed to get an S3 signed upload URL', err)
            })
        } else if (!vm.imageWidth) {
          // console.log('process non-image upload', file)
          const loader = vm.$loading.show()
          MediaService.getSignedURL(file)
            .then(resp => {
              if (resp && resp.data && resp.data.data && resp.data.data.url) {
                file.uploadURL = resp.data.data.url
                vm.uploadKey = resp.data.data.params.Key
                done()
                loader.hide()
                setTimeout(() => vm.dropzone.processFile(file))
              } else {
                loader.hide()
                done(
                  'Error getting a signed S3 upload URL',
                  resp.data.data.error
                )
              }
            })
            .catch(err => {
              loader.hide()
              done('Failed to get an S3 signed upload URL', err)
            })
          vm.$emit('input', file.name)
        }
      },
      previewTemplate: `
        <div class="dz-preview dz-file-preview">
          <div class="dz-wrapper">
            <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
            <div class="dz-filename">
              <span data-dz-name></span>
              <span class="dz-remove" data-dz-remove></span>
          </div>
          <div class="dz-error-message"><span data-dz-errormessage></span></div>
        </div>`
    }

    this.dropzone = new Dropzone(this.$el, options)

    this.dropzone.on('thumbnail', file => {
      if (file.cropped) return
      const vm = this
      // Create the image editor overlay
      vm.isModalOpen = true
      // vm.done = done
      vm.cachedFile = file
      vm.$refs.cropperImg.src = window.URL.createObjectURL(file)

      // Create Cropper.js
      setTimeout(() => {
        const maxHeight =
          0.6 *
          Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
          )
        vm.cropper = new Cropper(vm.$refs.cropperImg, {
          aspectRatio: vm.imageWidth / vm.imageHeight,
          viewMode: 2,
          background: false,
          autoCropArea: 1,
          minContainerHeight: Math.min(
            (file.height * vm.$refs.cropperImg.parentNode.offsetWidth) /
              file.width,
            maxHeight
          ),
          ready() {
            const oldChild = vm.$refs.preview
              .getElementsByTagName('img')
              .item(0)
            if (oldChild) vm.$refs.preview.removeChild(oldChild)

            const clone = this.cloneNode()
            clone.className = ''
            clone.style.cssText =
              'display: block;' +
              'width: 100%;' +
              'min-width: 0;' +
              'min-height: 0;' +
              'max-width: none;' +
              'max-height: none;'
            vm.$refs.preview.appendChild(clone.cloneNode())
            vm.updatePreview(vm.initialEvent)
          },
          crop(e) {
            vm.updatePreview(e.detail)
          }
        })
      })
    })

    this.dropzone.on('processing', file => {
      this.dropzone.options.url = file.uploadURL
    })
    this.dropzone.on('success', file => {
      if (file.status == 'success') {
        this.dropzone.disable()
        this.$emit('upload-key', this.uploadKey)
      }
    })
    this.dropzone.on('removedfile', () => {
      this.dropzone.enable()
      this.$emit('upload-key', false)
      this.$emit('input', false)
    })

    if (this.value) {
      const filename = this.value
        .split('\\')
        .pop()
        .split('/')
        .pop()
      const mockFile = { name: filename, size: 1234 }
      this.dropzone.emit('addedfile', mockFile)
      this.dropzone.emit('complete', mockFile)
    }

    if (this.viewonly) {
      this.dropzone.disable()
    }
  }
}
</script>

<style lang="scss" scoped>
.dz-hidden-input {
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
}
form.dropzone {
  border: 0;
  border-bottom: 1px solid;
  cursor: pointer;
  padding: em(14) 0;
  position: relative;
  min-height: initial;

  &.viewonly {
    /deep/ .dz-remove {
      display: none !important;
    }
  }

  &:hover {
    .dz-message {
      .dropzone-title .text {
        opacity: 1;
      }
    }
  }
  .dz-message {
    color: #666;

    span.dropzone-title {
      display: block;

      .text {
        margin-left: 1em;
        opacity: 0.5;
        transition: opacity 200ms;
        vertical-align: middle;
      }

      svg {
        display: inline-block;
        max-width: em(20);
        max-height: em(20);
        vertical-align: middle;
      }
    }
    span.dropzone-info {
      color: #898989;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &.dz-started {
    border-bottom-color: transparent;

    /deep/ .dz-message {
      display: none;
    }
  }

  /deep/ .dz-preview {
    cursor: default;

    .dz-filename {
      display: flex;
      position: relative;
      z-index: 2;

      .dz-remove {
        text-indent: -99999px;
        background: url('../assets/images/icons/cancel.svg?external') no-repeat center
          center;
        cursor: pointer;
        display: inline-block;
        margin-left: em(15);
        overflow: hidden;
        width: em(20);
        height: em(20);
      }
    }

    .dz-progress {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: opacity 200ms;

      .dz-upload {
        background-color: #35bdd1;
        display: block;
        height: 100%;
        width: 0;
        transition: width time;
      }
    }

    &.dz-complete {
      .dz-progress {
        opacity: 0;
      }
    }

    .dz-error-message {
      color: #eb3323;
    }
  }
}
.modal-crop {
  /deep/ .modal {
    width: 80%;

    .modal-body {
      display: flex;
      align-items: flex-start;

      .modal-crop-left {
        flex: 1;
        position: relative;
        max-width: calc(80vw - 370px);
        max-height: 60vh;
      }
      .modal-crop-right {
        flex: 0 0 270px;
        margin-left: 50px;
        position: relative;
        width: 270px;

        img {
          width: 100%;
        }

        .crop-wrapper {
          position: relative;
        }

        .crop-preview {
          background-color: #ddd;
          overflow: hidden;
          position: absolute;
          top: 0;
          left: 0;
          width: 270px;
          height: 0 !important;
        }
        .crop-preview-screen {
          display: block;
          position: relative;
          z-index: 2;
        }

        .error {
          color: #eb3323;
          margin-top: 25px;
        }
      }
    }
    .modal-footer {
      justify-content: space-between;
    }
  }
}
</style>
